import { ListItemButton, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ThreadSummaryListItemEmpty = () => {
  const { t } = useTranslation('cockpit', { keyPrefix: 'AgentPanel' });

  return (
    <ListItemButton disabled>
      <ListItemText
        sx={{ textAlign: 'center' }}
        slotProps={{
          primary: {
            variant: 'subtitle2',
            color: 'textSecondary',
          },
        }}
        primary={t('emptyCategory.title')}
        secondary={t('emptyCategory.description')}
      />
    </ListItemButton>
  );
};
